import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../../../../domain/theme';
import { conf } from '../../../../../domain/services/configService';
import { getHubPages } from '../../../../../domain/utils/contentUtils';
import { SmartLink } from '../../../../SmartLink';
import { DrupalEdit } from '../../../molecules/DrupalEdit';

const styles = {
  links: css`
    display: none;

    ${theme.mq.small_desktop} {
      display: flex;
      justify-content: center;
      align-items: center;
      li {
        height: 49px;
        ${theme.font.family('boldWeb')};
        font-size: ${theme.font.size('s')};
        letter-spacing: ${theme.letterSpacing('base')};
        text-transform: uppercase;
        margin: ${theme.spacing.parse('0 $xs')};
        color: #000;

        a {
          height: 49px;
          line-height: 15px;
          color: inherit;
          &:hover {
            color: #999;
          }
          display: grid;
          place-items: center;
        }
        &:hover {
          box-shadow: inset 0 -6px 0 0 #fc0;
        }
      }
    }
  `,
  active: css`
    box-shadow: inset 0 -6px 0 0 #fc0;
  `
};

export const LinksMenuItemDesktop = ({ content }) => {
  const hubPages = getHubPages(content, {
    sorted: false,
    includeParents: true
  });

  const mainHubPage = hubPages[0];

  let activeLink;
  // First, search for coincidences with the main hub page
  if (mainHubPage) {
    activeLink = conf.menus.menuMainNavigation.find(
      link => mainHubPage.url === link.url
    );
  }
  // If nothing found, search in all hub pages
  if (!activeLink) {
    activeLink = conf.menus.menuMainNavigation.find(link => {
      const pathsToCheck = hubPages.map(hubPage => hubPage.url);
      if (content.url?.path) {
        pathsToCheck.unshift(content.url.path);
      }
      return pathsToCheck.some(path => path?.startsWith(link.url));
    });
  }

  return (
    <ul css={styles.links}>
      {conf.menus.menuMainNavigation.map((link, index) => {
        return (
          <li
            key={link.title}
            className={link.containerClass}
            css={link === activeLink ? styles.active : undefined}
          >
            <SmartLink
              to={link.url}
              title={link.title}
              target={link.target}
              className={link.class}
              dataLayerClickEvent={
                link.dataLayerEvent
                  ? {
                      event: link.dataLayerEvent,
                      location: 'MainNavigationDesktop'
                    }
                  : undefined
              }
            >
              <span>{link.title}</span>
            </SmartLink>
            {index === conf.menus.menuMainNavigation.length - 1 && (
              <DrupalEdit entityType="menu" entityId="main" />
            )}
          </li>
        );
      })}
    </ul>
  );
};
LinksMenuItemDesktop.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired
};
